import { auth, db } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';

export const testFirebaseConnection = async () => {
  try {
    console.log('Testing Firebase connection...');
    
    // Try a simple query to test connection
    const testQuery = query(collection(db, 'cards'), where('deleted', '==', false));
    await getDocs(testQuery);
    
    console.log('Firebase connection successful');
    return true;
  } catch (error) {
    console.error('Firebase connection test failed:', error);
    return false;
  }
}; 